export enum AuthorizedPersonToRegistryViewControlName {
  NameSurname = 'nameSurname',
  Pesel = 'pesel'
}
